import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [
    'unexpandedDetailContent',
    'expandedDetailContent',
    'showDetailLink',
    'hideDetailLink',
    'revealDetailLink',
    'detailContent',
  ];

  expandedDetailContentTarget: HTMLElement;

  unexpandedDetailContentTarget: HTMLElement;

  showDetailLinkTarget: HTMLElement;

  hideDetailLinkTarget: HTMLElement;

  revealDetailLinkTarget: HTMLElement;

  detailContentTarget: HTMLElement;

  onClickSeeDetailLink(e: Event) {
    e.preventDefault();
    this.expandedDetailContentTarget.classList.remove('u-displayNone--until-md');
    this.unexpandedDetailContentTarget.remove();
  }

  showDetails(e: Event) {
    e.preventDefault();
    this.detailContentTarget.classList.remove('u-displayNone');
    this.hideDetailLinkTarget.classList.remove('u-displayNone');
    this.showDetailLinkTarget.classList.add('u-displayNone');
  }

  revealDetails(e: Event) {
    e.preventDefault();
    this.detailContentTarget.classList.remove('u-displayNone');
    this.revealDetailLinkTarget.classList.add('u-displayNone');
  }

  hideDetails(e: Event) {
    e.preventDefault();
    this.detailContentTarget.classList.add('u-displayNone');
    this.hideDetailLinkTarget.classList.add('u-displayNone');
    this.showDetailLinkTarget.classList.remove('u-displayNone');
  }
}
